var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { MEDIA_QUERIES } from 'shared/style';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  font-weight: 400;\n\n  > .title {\n    width: 100%;\n    ", " {\n      font-size: 40px;\n    }\n    ", " {\n      font-size: 36px;\n    }\n    height: 60px;\n  }\n\n  > .underbar {\n    width: 40px;\n    height: 5px;\n    ", " {\n      margin-top: 20px;\n    }\n    ", " {\n      margin-top: 10px;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  text-align: left;\n  font-weight: 400;\n\n  > .title {\n    width: 100%;\n    ", " {\n      font-size: 40px;\n    }\n    ", " {\n      font-size: 36px;\n    }\n    height: 60px;\n  }\n\n  > .underbar {\n    width: 40px;\n    height: 5px;\n    ", " {\n      margin-top: 20px;\n    }\n    ", " {\n      margin-top: 10px;\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE, MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var Title = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    var color = props.color || '#222';
    return (React.createElement(RootDiv, null,
        React.createElement("div", { className: "title", style: { color: color } },
            React.createElement("h2", { style: { display: 'none' } }, title),
            title),
        React.createElement("div", { className: "underbar", style: { backgroundColor: color } })));
};
export default Title;
var templateObject_1;
